import { render, staticRenderFns } from "./SelectedReservation.vue?vue&type=template&id=f0de1e08&scoped=true&"
import script from "./SelectedReservation.vue?vue&type=script&lang=js&"
export * from "./SelectedReservation.vue?vue&type=script&lang=js&"
import style0 from "./SelectedReservation.vue?vue&type=style&index=0&id=f0de1e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0de1e08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VDivider,VExpandTransition,VHover,VIcon,VRow,VSlideYTransition})
